import { DateTime } from 'luxon';

const getTodaysDateFormatted = (): string => {
  return DateTime.now().toUTC().startOf('day').toISODate();
};

export const getPlacementsDefaultFilter = (): string => {
  return `?fromDate=${getTodaysDateFormatted()}`;
};
